export default __webpack_public_path__ + "static/media/1558.04dcf66b.png";